import { EmptyState, FlexColumn, useStyles } from '@gorila-shared-ui/components';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { NotificationEvidence } from '../../types/notification';
import { NotificationOrigin } from '../../types/notificationConfig';
import NotificationEvidenceMediaItem from './NotificationEvidenceMediaItem';

type Props = {
  notificationId: string;
  origin: NotificationOrigin;
  evidences: NotificationEvidence[];
};

function NotificationEvidencesLibrary({ notificationId, evidences, origin }: Readonly<Props>) {
  const { css } = useStyles();

  if (!evidences?.length) {
    return <EmptyState title="No cuenta con registros de evidencias." />;
  }

  return (
    <FlexColumn classNames={`${css({ flex: 1, overflow: 'hidden' })}`}>
      <FlexGrid
        flexGridColumnCount={[1, 1, 1, 1, 2]}
        flexGridColumnGap="scale600"
        flexGridRowGap="scale600"
        overflow="auto"
      >
        {evidences.map((media, mediaIndex) => (
          <FlexGridItem
            display="flex"
            key={mediaIndex}
            style={{ position: 'relative' }}
          >
            <NotificationEvidenceMediaItem
              notificationId={notificationId}
              media={media}
              origin={origin}
            />
          </FlexGridItem>
        ))}
      </FlexGrid>
    </FlexColumn>
  );
}

export default NotificationEvidencesLibrary;
